import React, {useContext, Fragment} from "react";
import {BrowserRouter as Router} from 'react-router-dom';
import FarmerBaseLayout from './components/layouts/farmer/FarmerBaseLayout';
import AuthScreen from "./screens/AuthScreen";
import authContext from "./context/auth/authContext";

import FarmerState from "./context/farmer/FarmerState";
import OperatorState from "./context/operator/OperatorState";
import OperatorBaseLayout from './components/layouts/operator/OperatorBaseLayout';
import FarmerRoutes from "./routes/FarmerRoutes";
import OperatorRoutes from "./routes/OperatorRoutes";
import PublicRoutes from "./routes/PublicRoutes";

const App = () => {


    const AuthContext = useContext(authContext);
    const {auth} = AuthContext
    let {logged_in, side_bar_toggle} = auth
    let user_type_id;

    if (logged_in) {
        user_type_id = JSON.parse(localStorage.getItem("userInfo")).user_type_id;
    }

    return (

        <FarmerState>
            <OperatorState>
                <Router>
                    <div className='App'>
                        <div id="wrapper" className={side_bar_toggle}>
                            {!logged_in ? (
                                <AuthScreen>
                                    <PublicRoutes/>
                                </AuthScreen>
                            ) : (
                                <Fragment>
                                    {user_type_id === 1 ? (
                                        <FarmerBaseLayout>
                                            <FarmerRoutes/>
                                        </FarmerBaseLayout>
                                    ) : (
                                        <OperatorBaseLayout>
                                            <OperatorRoutes/>
                                        </OperatorBaseLayout>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    </div>
                </Router>
            </OperatorState>
        </FarmerState>
    );
}

export default App;
